export const GET_PRICE_LIST_DEFAULT: string = 'GET_PRICE_LIST_DEFAULT';
export const SET_PRICE_LIST_DEFAULT: string = 'SET_PRICE_LIST_DEFAULT';